// Interviews → compact cards: name + candidate/job + status badge + when.
// Backend columns: ["Name","Candidate","Job","Status","When"]; ids are ATS
// interview ids and hrefs deep-link to the candidate.

import type { BlockOutput } from '../../types';
import { pluralise } from '../pluralise';
import { posNum, str } from './guards';
import { colReader, mapSuggestedActions } from './shared';
import type { StructuredTable } from './types';

export const buildInterviewListBlock = (
  t: StructuredTable,
  toolCallId?: string
): BlockOutput => {
  const rows = t.rows ?? [];
  const ids = t.ids ?? [];
  const hrefs = t.hrefs ?? [];
  const metas = t.row_meta ?? [];
  const total = t.total ?? rows.length;
  const col = colReader(t.columns);
  const interviews = rows.map((r, i) => {
    const m = metas[i] ?? {};
    return {
      id: ids[i] ?? String(i),
      title: col(r, 'Name') || col(r, 'Candidate') || 'Interview',
      candidate: col(r, 'Candidate'),
      job: col(r, 'Job'),
      status: col(r, 'Status'),
      when: col(r, 'When'),
      startTime: posNum(m.start_time),
      endTime: posNum(m.end_time),
      location: str(m.location),
      participants: Array.isArray(m.participants)
        ? m.participants.filter(Boolean).map(String)
        : undefined,
      url: hrefs[i] || undefined,
    };
  });
  const summary =
    total > rows.length
      ? `${pluralise(total, 'interview')} — showing top ${rows.length}.`
      : `${pluralise(total, 'interview')}.`;
  return {
    type: 'interviewList',
    data: {
      summary,
      interviews,
      suggestedActions: mapSuggestedActions(t.suggested_actions),
      ids,
      toolCallId,
    },
  };
};
